import React, { memo } from "react";
import { TableRow, TableRowProps } from "@mui/material";

const AppTableRow = ({ children, sx, ...otherProps }: TableRowProps) => {
  return (
    <TableRow
      hover
      sx={{
        // ghi đè css của AppHTMLRender nếu có table
        "& table": {
          "& tr": {
            backgroundColor: "unset !important",

            "&&:hover": {
              backgroundColor: "unset !important",
            },
          },

          "& td": {
            backgroundColor: "unset !important",
            minWidth: "50px !important",
          },
        },

        "&&:hover": {
          backgroundColor: "#e7f1fe",
        },
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </TableRow>
  );
};

export default memo(AppTableRow);
